import Alert from '@material-ui/lab/Alert';
import { Snackbar, Slide } from '@material-ui/core';
import { memo, useEffect } from 'react';
import { sleep } from '../../utility/common';

function Qalert({ open, set, type, text = '', time = 5000, onDemandClose = false }) {
  useEffect(() => {
    if (open && !onDemandClose) {
      sleep(time).then(() => {
        set(false);
      });
    }
  }, [open, set, onDemandClose, time]);

  return (
    <Snackbar
      className="snackbar-wrapper"
      data-testid="snack-bar"
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      key="top, right"
      open={open}
      TransitionComponent={(props) => <Slide {...props} direction="left" />}
    >
      <Alert className={`q-alert ${type || 'success'}`} severity={type || 'success'}>
        {type === 'error' ? (text ? text : 'Oops! Something Went Wrong. Please try again.') : text}
      </Alert>
    </Snackbar>
  );
}

export default memo(Qalert);
